// 投诉路由
export default [
  {
    // dealover首页
    path: '/complaint/dealover',
    component: () => import('../../pages/complaint/views/dealover/index.vue')
  },
  {
    // leader首页
    path: '/complaint/leader',
    meta: {
      title: '我的工作台'
    },
    component: () => import('../../pages/complaint/views/leader/index.vue')
  },
  {
    // 处理组预警公用列表
    path: '/complaint/warningList',
    meta: {
      title: '投诉列表'
    },
    component: () =>
      import('../../pages/complaint/views/list/workerList/warningList.vue')
  },
  {
    // 处理组列表1
    path: '/complaint/workerListFirst',
    name: 'leaderList2',
    meta: {
      title: '投诉列表'
    },
    component: () =>
      import('../../pages/complaint/views/list/workerList/workerListFirst.vue')
  },
  {
    // 处理组列表2
    path: '/complaint/workerListSec',
    meta: {
      title: '投诉列表'
    },
    component: () =>
      import('../../pages/complaint/views/list/workerList/workerListSec.vue')
  },
  {
    // 处理组列表3
    path: '/complaint/workerListThird',
    meta: {
      title: '投诉列表'
    },
    component: () =>
      import('../../pages/complaint/views/list/workerList/workerListThird.vue')
  },
  {
    // 处理组列表旅发委
    path: '/complaint/workerListForth',
    meta: {
      title: '投诉列表'
    },
    component: () =>
      import('../../pages/complaint/views/list/workerList/workerListForth.vue')
  },
  {
    // 处理组督办列表
    path: '/complaint/workerListFif',
    meta: {
      title: '投诉列表'
    },
    component: () =>
      import('../../pages/complaint/views/list/workerList/workerListFif.vue')
  },
  {
    // leader列表落点分布
    path: '/complaint/leaderListSec',
    meta: {
      title: '投诉列表'
    },
    component: () =>
      import('../../pages/complaint/views/list/leaderList/leaderListSec.vue')
  },
  {
    // leader列表页详情
    path: '/complaint/leadList1',
    meta: {
      title: '投诉列表'
    },
    component: () => import('../../pages/complaint/views/leader/leadList1.vue')
  },
  {
    // 领导组列表列表1
    path: '/complaint/leaderListFirst',
    meta: {
      title: '投诉列表'
    },
    component: () =>
      import('../../pages/complaint/views/list/leaderList/leaderListFirst.vue')
  },
  {
    // 领导时限预警列表
    path: '/complaint/timeLimitList',
    meta: {
      title: '投诉列表'
    },
    component: () =>
      import('../../pages/complaint/views/list/leaderList/timeLimitList.vue')
  },
  {
    // 领导组紧急程度列表
    path: '/complaint/earlyWarning',
    meta: {
      title: '投诉列表'
    },
    component: () =>
      import('../../pages/complaint/views/list/leaderList/earlyWarning.vue')
  },
  {
    // 领导组关注列表/其他关注列表(类型(query参数type):1.myAttention我的关注列表；2.otherAttention其他关注列表)
    path: '/complaint/attention',
    meta: {
      title: '我的关注'
    },
    component: () =>
      import('../../pages/complaint/views/list/leaderList/attentionList.vue')
  },
  {
    // 领导组督办列表/其他督办列表  (类型(query参数type):1.mySupervision我的督办列表；2.otherSupervision其他督办列表)
    path: '/complaint/handle',
    meta: {
      title: '投诉列表'
    },
    component: () =>
      import('../../pages/complaint/views/list/leaderList/handleList.vue')
  },
  // {
  //     // 领导组我的督办列表
  //     path: '/complaint/myHandleList',
  //     meta: {
  //         title: '其他督办'
  //     },
  //     component: () =>
  //         import ('../../pages/complaint/views/list/leaderList/myHandleList.vue')
  // },
  {
    // 年月周日状态事件列表
    path: '/complaint/statusList',
    meta: {
      title: '投诉列表'
    },
    component: () =>
      import('../../pages/complaint/views/listDetails/statusList.vue')
  },
  {
    // 领导组处理组综合预警列表
    path: '/complaint/comprehensiveWarningList',
    meta: {
      title: '综合预警列表'
    },
    component: () =>
      import(
        '../../pages/complaint/views/list/commonList/comprehensiveWarningList.vue'
      )
  },
  {
    // 处理者主页
    path: '/complaint/worker',
    meta: {
      title: '投诉'
    },
    component: () => import('../../pages/complaint/views/work/index.vue')
  },
  {
    // 信息补充核实
    path: '/complaint/informationSupplement',
    meta: {
      title: '信息补充核实'
    },
    component: () =>
      import('../../pages/complaint/views/operate/informationSupplement.vue')
  },
  {
    // 结案
    path: '/complaint/settleLawsuit',
    name: 'settleLawsuit',
    meta: {
      title: '结案',
      dec: '结案原因'
    },
    component: () =>
      import('../../pages/complaint/views/operate/settleLawsuit.vue')
  },
  {
    // 撤案
    path: '/complaint/withdrawCase',
    name: 'withdrawCase',
    meta: {
      title: '撤案',
      dec: '撤案原因'
    },
    component: () =>
      import('../../pages/complaint/views/operate/withdrawCase.vue')
  },

  {
    // 不予立案
    path: '/complaint/dontFiling',
    meta: {
      title: '不予立案'
    },
    component: () =>
      import('../../pages/complaint/views/operate/dontFiling.vue')
  },
  {
    // 绑定电子合同
    path: '/complaint/electronicContract',
    meta: {
      title: '绑定电子合同'
    },
    component: () =>
      import('../../pages/complaint/views/operate/electronicContract.vue')
  },
  {
    // 绑定电子合同详情
    path: '/complaint/electronicDetails',
    meta: {
      title: '绑定电子合同'
    },
    component: () =>
      import('../../pages/complaint/views/operate/electronicDetails.vue')
  },
  {
    // 操作页面
    // 导游绑定页面
    path: '/complaint/guideListQuery',
    meta: {
      title: '绑定导游'
    },
    component: () =>
      import('../../pages/complaint/views/operate/guideListQuery.vue')
  },
  {
    // 解除导游绑定页面
    path: '/complaint/unbundleGuide',
    meta: {
      title: '解除绑定导游'
    },
    component: () =>
      import('../../pages/complaint/views/operate/unbundleGuide.vue')
  },
  {
    // 旅行社绑定页面
    path: '/complaint/travelListQuery',
    meta: {
      title: '绑定旅行社'
    },
    component: () =>
      import('../../pages/complaint/views/operate/travelListQuery.vue')
  },
  {
    // 解除旅行社绑定页面
    path: '/complaint/unbundleTravle',
    meta: {
      title: '解除旅行社绑定'
    },
    component: () =>
      import('../../pages/complaint/views/operate/unbundleTravle.vue')
  },
  {
    // 督办回复
    path: '/complaint/supervisorReply',
    meta: {
      title: '督办受理'
    },
    component: () =>
      import('../../pages/complaint/views/operate/supervisorReply.vue')
  },
  {
    // 导游详情
    path: '/complaint/guideDetails',
    meta: {
      title: '导游详情'
    },
    component: () =>
      import('../../pages/complaint/views/operate/guideDetails.vue')
  },
  {
    // 旅行社详情
    path: '/complaint/travelAgencyDetails',
    meta: {
      title: '旅游详情'
    },
    component: () =>
      import('../../pages/complaint/views/operate/travelAgencyDetails.vue')
  },
  {
    // 结果反馈
    path: '/complaint/feedback',
    meta: {
      title: '处置反馈'
    },
    component: () => import('../../pages/complaint/views/operate/feedback.vue')
  },
  {
    // 投诉处置
    path: '/complaint/disposal',
    meta: {
      title: '投诉处置'
    },
    component: () => import('../../pages/complaint/views/operate/disposal.vue')
  },
  {
    // 不予受理
    path: '/complaint/inadmissible',
    meta: {
      title: '不予受理'
    },
    component: () =>
      import('../../pages/complaint/views/operate/inadmissible.vue')
  },
  {
    // 上报确认
    path: '/complaint/escalationConfirmation',
    meta: {
      title: '上报'
    },
    component: () =>
      import('../../pages/complaint/views/operate/escalationConfirmation.vue')
  },
  {
    // 拆单分发
    path: '/complaint/splitOrderDistribution',
    component: () =>
      import('../../pages/complaint/views/operate/splitOrderDistribution.vue'),
    meta: {
      keepAlive: true,
      title: '分发'
    }
  },
  {
    // 告知部门
    path: '/complaint/informDepartment',
    meta: {
      title: '告知部门'
    },
    component: () =>
      import('../../pages/complaint/views/operate/informDepartment.vue')
  },
  {
    // 上报审核拒绝
    path: '/complaint/escalationReview',
    meta: {
      title: '上报审核不通过'
    },
    component: () =>
      import('../../pages/complaint/views/operate/escalationReview.vue')
  },
  {
    // 上报审核通过
    path: '/complaint/examinationPassed',
    meta: {
      title: '上报审核通过'
    },
    component: () =>
      import('../../pages/complaint/views/operate/examinationPassed.vue')
  },
  {
    // 上报审核
    path: '/complaint/initiateSupervision',
    meta: {
      title: '上报审核'
    },
    component: () =>
      import('../../pages/complaint/views/operate/initiateSupervision.vue')
  },
  {
    // 拆单通过
    path: '/complaint/decommissioningPass',
    meta: {
      title: '拆单通过',
      keepAlive: true
    },
    component: () =>
      import('../../pages/complaint/views/operate/decommissioningPass.vue')
  },
  {
    // 拆单不通过
    path: '/complaint/failureopenOrder',
    meta: {
      title: '拆单不通过'
    },
    component: () =>
      import('../../pages/complaint/views/operate/failureopenOrder.vue')
  },
  {
    // 申诉审核不通过
    path: '/complaint/appealReviewFailed',
    meta: {
      title: '申诉审核不通过'
    },
    component: () =>
      import('../../pages/complaint/views/operate/appealReviewFailed.vue')
  },
  {
    // 督办
    path: '/complaint/supervise',
    meta: {
      title: '督办'
    },
    component: () => import('../../pages/complaint/views/operate/supervise.vue')
  },
  {
    // 处理结束
    path: '/complaint/processingEnd',
    meta: {
      title: '投诉反馈'
    },
    component: () =>
      import('../../pages/complaint/views/operate/processingEnd.vue')
  },
  {
    // 转办至下级
    path: '/complaint/transferSubordinate',
    meta: {
      title: '转办至下级'
    },
    component: () =>
      import('../../pages/complaint/views/operate/transferSubordinate.vue')
  },
  {
    // 选择添加的指挥中心
    path: '/complaint/chooseCommandCenter',
    meta: {
      title: '添加指挥中心'
    },
    component: () =>
      import('../../pages/complaint/views/operate/chooseCommandCenter.vue')
  },
  {
    // 退回12301
    path: '/complaint/back12301',
    meta: {
      title: '退回12301'
    },
    component: () => import('../../pages/complaint/views/operate/back12301.vue')
  },
  {
    // 添加指挥中心
    path: '/complaint/addCommandCenter',
    meta: {
      title: '添加指挥中心'
    },
    component: () =>
      import('../../pages/complaint/views/operate/addCommandCenter.vue')
  },
  {
    // 调解失败
    path: '/complaint/mediationFails',
    meta: {
      title: '调解失败'
    },
    component: () =>
      import('../../pages/complaint/views/operate/mediationFails.vue')
  },
  {
    // 调解成功
    path: '/complaint/successMediation',
    meta: {
      title: '调解成功'
    },
    component: () =>
      import('../../pages/complaint/views/operate/successMediation.vue')
  },
  {
    // 搜索框
    path: '/complaint/select',
    meta: {
      title: '搜索'
    },
    component: () => import('../../pages/complaint/views/operate/select.vue')
  },
  {
    // 调解失败2
    path: '/complaint/mediationFailTwo',
    meta: {
      title: '调解失败'
    },
    component: () =>
      import('../../pages/complaint/views/operate/mediationFailTwo.vue')
  },
  {
    // 调解成功2
    path: '/complaint/successMediationTwo',
    meta: {
      title: '调解成功'
    },
    component: () =>
      import('../../pages/complaint/views/operate/successMediationTwo.vue')
  },
  {
    // 补充办结材料
    path: '/complaint/getThroughData',
    meta: {
      title: '补充办结材料'
    },
    component: () =>
      import('../../pages/complaint/views/operate/getThroughData.vue')
  },
  {
    // 告知部门
    path: '/complaint/tellCommand',
    meta: {
      title: '告知部门'
    },
    component: () =>
      import('../../pages/complaint/views/operate/tellCommand.vue')
  },
  {
    // 跳转
    path: '/complaint/redirectDetail',
    meta: {
      title: ''
    },
    component: () =>
      import('../../pages/complaint/views/detail/redirectDetail.vue')
  },
  {
    // 回访单列表
    path: '/complaint/returnList',
    meta: {
      title: '投诉列表'
    },
    component: () =>
      import('../../pages/complaint/views/list/commonList/returnList.vue')
  },
  {
    // 投诉件退回
    path: '/complaint/return',
    meta: {
      title: '退回原因'
    },
    component: () => import('../../pages/complaint/views/operate/return.vue')
  },
  {
    // 结果完善
    path: '/complaint/resultDetail',
    meta: {
      title: '办结反馈'
    },
    component: () =>
      import('../../pages/complaint/views/operate/resultDetail.vue')
  },
  {
    // 回访单列表
    path: '/complaint/returnDetail',
    meta: {
      title: '回访单详情'
    },
    component: () =>
      import('../../pages/complaint/views/list/commonList/returnDetail.vue')
  },
  {
    // 考核跳转的投诉列表
    path: '/complaint/checkList',
    meta: {
      title: '投诉列表'
    },
    component: () =>
      import('../../pages/complaint/views/list/commonList/checkList.vue')
  },
  {
    path: '/complaint/detailList',
    meta: {
      title: '投诉详情'
    },
    component: () =>
      import('../../pages/complaint/views/detail/leaderDetail.vue'),
    children: [
      {
        path: '/complaint/detailList',
        redirect: '/complaint/detailList/complaintSheet'
      },
      {
        path: 'complaintSheet',
        name: 'workListDetails',
        component: () =>
          import('../../pages/complaint/views/detail/complaintSheet.vue'),
        meta: {
          title: '投诉详情'
        }
      },
      {
        path: 'writeInfo',
        component: () =>
          import('../../pages/complaint/views/detail/writeInfo.vue'),
        meta: {
          title: '投诉详情'
        }
      },
      {
        path: 'saveInfo',
        component: () =>
          import('../../pages/complaint/views/detail/saveInfo.vue'),
        meta: {
          title: '投诉详情'
        }
      },
      {
        path: 'phoneHistory',
        component: () =>
          import('../../pages/complaint/views/detail/phoneHistory.vue'),
        meta: {
          title: '投诉详情'
        }
      },
      {
        path: 'timeLine',
        component: () =>
          import('../../pages/complaint/views/detail/timeLine.vue'),
        meta: {
          title: '投诉详情'
        }
      },
      {
        path: 'perfect',
        component: () =>
          import('../../pages/complaint/views/detail/perfect.vue'),
        meta: {
          title: '投诉详情'
        }
      }
    ]
  },
  {
    path: '/complaint/visual',
    meta: {
      title: '数据可视化'
    },
    component: () => import('../../pages/complaint/views/visual/index.vue'),
    children: [
      {
        path: '/complaint/visual',
        redirect: '/complaint/visual/complainAnalysis'
      },
      // {
      //     path: 'area',
      //     component: () =>
      //         import ('../../pages/complaint/views/visual/area/index.vue'),
      //     meta: {
      //         title: '数据可视化'
      //     }
      // },
      // {
      //   path: 'model',
      //   component: () =>
      //     import('../../pages/complaint/views/visual/model/index.vue'),
      //   meta: {
      //     title: '数据可视化'
      //   }
      // },
      // {
      //   path: 'source',
      //   component: () =>
      //     import('../../pages/complaint/views/visual/source/index.vue'),
      //   meta: {
      //     title: '数据可视化'
      //   }
      // },
      // {
      //   path: 'way',
      //   component: () =>
      //     import('../../pages/complaint/views/visual/way/index.vue'),
      //   meta: {
      //     title: '数据可视化'
      //   }
      // }
      {
        path: 'disposalAnalysis',
        component: () =>
          import(
            '../../pages/complaint/views/visual/disposalAnalysis/index.vue'
          ),
        meta: {
          title: '数据可视化'
        }
      },
      {
        path: 'touristAnalysis',
        component: () =>
          import(
            '../../pages/complaint/views/visual/touristAnalysis/index.vue'
          ),
        meta: {
          title: '数据可视化'
        }
      },
      {
        path: 'area',
        component: () =>
          import(
            '../../pages/complaint/views/visual/complainAnalysis/index.vue'
          ),
        meta: {
          title: '数据可视化'
        }
      }
    ]
  },
  {
    path: '/complaint/detailListAssess',
    meta: {
      title: '投诉详情'
    },
    component: () =>
      import('../../pages/complaint/views/assessDetail/leaderDetailAssess.vue'),
    children: [
      {
        path: '/complaint/detailListAssess',
        redirect: '/complaint/detailListAssess/complaintSheetAssess'
      },
      {
        path: 'complaintSheetAssess',
        name: 'assessDetails',
        component: () =>
          import(
            '../../pages/complaint/views/assessDetail/complaintSheetAssess.vue'
          ),
        meta: {
          title: '投诉详情'
        }
      },
      {
        path: 'writeInfoAssess',
        component: () =>
          import(
            '../../pages/complaint/views/assessDetail/writeInfoAssess.vue'
          ),
        meta: {
          title: '投诉详情'
        }
      },
      {
        path: 'phoneHistoryAssess',
        component: () =>
          import(
            '../../pages/complaint/views/assessDetail/phoneHistoryAssess.vue'
          ),
        meta: {
          title: '投诉详情'
        }
      },
      {
        path: 'timeLineAssess',
        component: () =>
          import('../../pages/complaint/views/assessDetail/timeLineAssess.vue'),
        meta: {
          title: '投诉详情'
        }
      }
    ]
  },
  {
    // 导旅跳转的投诉列表
    path: '/complaint/guideOrTravelList',
    meta: {
      title: '投诉列表'
    },
    component: () =>
      import(
        '../../pages/complaint/views/list/commonList/guideOrTravelList.vue'
      )
  },
  {
    // 图片预览
    path: '/complaint/imagesView',
    meta: {
      title: '图片预览'
    },
    component: () => import('../../components/imageView.vue')
  }
];
